/**
 * Micro-moos entry point. The page is complete without this file: the feed, the filter
 * and the counts are all server-rendered. What loads here is the theme toggle, the
 * lightbox for attached images, the heart buttons, and -- only when the server rendered
 * the page for an admin session -- the compose/edit dialogs.
 */

import { initLightbox } from '../home/lightbox.js';
import { initThemeToggle } from '../home/theme-toggle.js';

initThemeToggle(document.querySelector('.theme-toggle'));
// Attached images open big, exactly like the favorites shelf -- same script, same dialog.
initLightbox(document.querySelector('.lightbox'), document.querySelector('.herd'));

/* ------------------------------------------------------------------ Hearts */

/**
 * A heart is a toggle and the server is the truth: the button repaints from the response,
 * not from what it hoped happened. Disabled while in flight so a double-tap can't race.
 */
for (const btn of document.querySelectorAll('.moo__like')) {
  btn.addEventListener('click', async () => {
    const id = btn.closest('.moo')?.dataset.id;
    if (!id) return;
    btn.disabled = true;
    try {
      const res = await fetch(`/api/moos/${id}/like`, { method: 'POST' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const { liked, count } = await res.json();
      btn.classList.toggle('moo__like--on', liked);
      btn.querySelector('.moo__like-heart').textContent = liked ? '♥' : '♡';
      btn.querySelector('.moo__like-n').textContent = count;
      btn.setAttribute('aria-label', liked ? 'unlike' : 'like');
    } catch {
      /* a heart that didn't land isn't worth an error state; try again */
    } finally {
      btn.disabled = false;
    }
  });
}

if (document.body.hasAttribute('data-admin')) {
  // Static import would ship admin code to every visitor for nothing.
  import('./admin.js').then(({ initAdmin }) => initAdmin());
}
